<template>
  <div>
    <ThePageTitleVue>
        <h3>{{ $t('platform_2') }}</h3>
        <p>{{ $t('platform_3') }}</p>
    </ThePageTitleVue>
    <div class="content p-wrap">
      <div class="p-f">
        <p class="title" style="border-right: 1px solid #D7DDE1;">{{ $t('platform_4') }}</p>
        <p class="title">{{ $t('platform_11') }}</p>
      </div>
      <div class="p-f">
        <p class="desc" style="border-right: 1px solid #D7DDE1;">{{ $t('platform_5') }}</p>
        <p class="desc">{{ $t('platform_12') }}</p>
      </div>

      <div class="p-f">
        <div class="d-btn" style="border-right: 1px solid #D7DDE1;">
          <a href="https://play.google.com/store/apps/details?id=com.wtmob.app" target="_blank">
            <img src="../assets/images/GooglePlay@2x.png" style="width: 140px; margin-right: 18px;" alt="">
          </a>
          <a href="https://apps.apple.com/in/app/wetrade-market-data-and-news/id1604139836" target="_blank">
            <img src="../assets/images/AppStore@2x.png" style="width: 140px;" alt="">
          </a>   
        </div>
        <div class="d-btn">
          <a href="https://webtrader.wetrade.one/" target="_blank">
            <img src="../assets/images/Web@2x.png" style="width: 300px" alt="">
          </a>
        </div>
      </div>

      <div class="p-f">
        <div class="pf-img" style="border-right: 1px solid #D7DDE1;">
          <img src="../assets/images/p_mobile@2x.png" style="width: 500px" alt="">
        </div>
        <div class="pf-img">
          <img src="../assets/images/p_web@2x.png" style="width: 500px" alt="">
        </div>
      </div>

      <div class="p-f">
        <div class="items" style="border-right: 1px solid #D7DDE1;">
          <div class="item" v-for="(item, index) in mobileTips" :key="index">
            <img src="../assets/images/check.png" alt="">
            <p>{{ item }}</p>
          </div>
        </div>
        <div class="items">
          <div class="item" v-for="(item, index) in pcTips" :key="index">
            <img src="../assets/images/check.png" alt="">
            <p>{{ item }}</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ThePageTitleVue from "./home/ThePageTitle.vue"
export default {
  name: 'Platforms',
  components: {
    ThePageTitleVue,
  },
  data(){
    return{
      mobileTips: [
        this.$t('platform_6'),
        this.$t('platform_7'),
        this.$t('platform_8'),
        this.$t('platform_9'),
        this.$t('platform_10'),
      ],
      pcTips: [
        this.$t('platform_13'),
        this.$t('platform_14'),
        this.$t('platform_15'),
      ],
    }
  }
}
</script>

<style scoped lang="scss">
.p-wrap{
  padding-top: 80px;
  padding-bottom: 128px;
  .p-f{
    display: flex;
    width: 100%;
    .title{
      flex: 1;
      font-size: 32px;
      font-weight: bold;
      color: #181D24;
      line-height: 40px;
      display: block;
      text-align: center;
    }
    .desc{
      flex: 1;
      font-size: 16px;
      font-weight: 400;
      color: #5C6E7B;
      line-height: 24px;
      padding: 0 95px;
      padding-top: 50px;
      text-align: center;
    }
    .d-btn{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 30px;
      padding-bottom: 60px;
    }
    .pf-img{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .items{
      flex: 1;
      padding: 0 105px;
      padding-top: 60px;
      padding-bottom: 30px;
      .item{
        display: flex;
        margin-top: 34px;
        img{
          height: 16px;
          width: 16px;
          margin-top: 4px;
          margin-right: 24px;
        }
        p{
          font-size: 16px;
          font-weight: 400;
          color: #5C6E7B;
          line-height: 24px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Platforms.vue